import React from "react";
import Image from "next/image";

const PaymentIcon: React.FC<{
  alt: string;
  src: string;
}> = ({ src, alt }) => (
  <Image
    src={src}
    alt={alt}
    width={55}
    height={35}
    className="h-[22px] w-[35px] lg:h-[35px] lg:w-[55px]"
  />
);

export default PaymentIcon;
